<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">play_arrow</mat-icon>
        <span>
            {{title}}
        </span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn" *ngIf="!(transactionStarted$|async)">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-horizontal-stepper *ngIf="!(transactionStarted$|async) && !(transactionFinished|async)" [(selectedIndex)]="stepperIndex" #stepper class="stepper" (selectionChange)="stepperChanged($event)">

            <ng-container *ngFor="let step of visibleSteps; let i = index">

                <mat-step [stepControl]="step.formGroup">

                    <ng-template matStepLabel>{{step.title}}</ng-template>

                </mat-step>

            </ng-container>

        </mat-horizontal-stepper>

        <div class="dynamic-content-wrapper">

            <ng-template #dynamicInner></ng-template>
            
        </div>

    </div>

    <div class="footer">

        <ng-container *ngIf="!(transactionStarted$|async) && !(transactionFinished|async); else transactionDetails">

            <button mat-raised-button [disabled]="!hasPreviousStep" (click)="previousStep()">
                Zurück
            </button>
    
            <div class="spacer"></div>
    
            <button mat-raised-button [disabled]="!hasNextStep" (click)="nextStep()">
                Weiter
            </button>
            
            <button class="execute-transaction-button" mat-raised-button color="primary" [disabled]="hasNextStep || formGroup.invalid" (click)="executeTransaction()">
                Transaktion ausführen
            </button>

        </ng-container>

    </div>

</div>

<ng-template #transactionDetails>

    <app-persistence-state-array [transaction]="transactionGuid" style="flex: 1;"></app-persistence-state-array>

</ng-template>